<template>
	<Modal
		v-if="showModal"
		:max-width="'max-w-[540px]'"
		:hide-actions="true"
		:close-button-absolute="true"
		@modal:close="servicesNudgesStore.closeModal"
	>
		<template #body>
			<component :is="featureComponent" />
		</template>
	</Modal>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useServicesNudges } from '../../store/services-nudges.store';

import Modal from '../../components/modal.vue';
import ResumAINudge from './components/resume-nudge.vue';
import AutoApplyNudge from './components/auto-apply-nudge.vue';
import JobTrackerNudge from './components/job-tracker-nudge.vue';

const servicesNudgesStore = useServicesNudges();
const { showModal, selectedFeature } = storeToRefs(servicesNudgesStore);

const FEATURE_NUDGE_MAP = {
	resum_ai: ResumAINudge,
	auto_apply: AutoApplyNudge,
	job_tracker_ai: JobTrackerNudge
};

const featureComponent = computed(() => {
	return FEATURE_NUDGE_MAP[selectedFeature.value];
});
</script>
